import { ProfileCard } from "@/components/molecules/UserCard"
import { User } from "@/components/molecules/UserCard/featured"

type ProfilesProps = {
  profiles: User[]
}

export const UserProfileList = ({ profiles, translations }: ProfilesProps & { translations: Record<string, any> }) => {
  return (
    <div className="grid w-full grid-cols-1 items-start gap-1 gap-y-8 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {profiles.map((profile) => (
        <ProfileCard key={profile.id} profile={profile} translations={translations} />
      ))}
    </div>
  )
}
